import { render, staticRenderFns } from "./Pdfs.vue?vue&type=template&id=33fb9a4c&"
import script from "./Pdfs.vue?vue&type=script&lang=js&"
export * from "./Pdfs.vue?vue&type=script&lang=js&"
import style0 from "./Pdfs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports